import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { isValidQuery } from '@modules/quantify/utils';

interface HasChangesToBeSavedOptions {
  shouldCheckForValidQuery?: boolean;
}

export const useHasChangesToBeSaved = ({
  shouldCheckForValidQuery = false,
}: HasChangesToBeSavedOptions = {}): boolean => {
  const hasQueryChanged = useQuantifyStore(
    ({ visual }) => visual.hasQueryChanged,
  );

  const isValidQueryState = useQuantifyStore(({ query }) =>
    isValidQuery(query),
  );

  if (!shouldCheckForValidQuery) {
    return hasQueryChanged;
  }

  return hasQueryChanged && isValidQueryState;
};
